import { AgGridReact } from 'ag-grid-react';
import { useRef } from 'react';
import Header from '../../common/Header/Header';
import { Page, TableWrapper } from '../../common/TableWithButtonsRightLayout/TableWithButtonsRightLayout.styles';
import Table from '../../components/Table/Table';
import { readOnlyLabelTableText } from '../../constants/GlobalTexts';
import { useCriteria } from '../../services/criteria/criteria.service';
import { useFetchErrorToast } from '../../utils/useFetchErrorToasts/useFetchErrorToast';

const Criteria = () => {
  const gridRef = useRef<AgGridReact>(null);
  const { data, isError } = useCriteria();

  useFetchErrorToast([{ isError, label: 'Error fetching criteria', id: 'criteriaFetchError' }]);

  return (
    <>
      <Header breadcrumb={{ to: '/tables', label: 'All tables' }} title='Criteria' titleTestId={'CriteriaPageTitle'} />
      <Page>
        <TableWrapper>
          <Table
            rowData={data?.data}
            ref={gridRef}
            height={'100%'}
            returnedRecords={data?.data?.length}
            readOnlyLabel={readOnlyLabelTableText}
            columnDefs={[
              { minWidth: 100, field: 'storeNo', headerName: 'Store No.' },
              { minWidth: 100, field: 'marketNo', headerName: 'Market No.' },
              { minWidth: 100, field: 'critDescription', headerName: 'Crit Description' },
              { minWidth: 100, field: 'critGroupDescription', headerName: 'Crit Group Description' },
            ]}
          />
        </TableWrapper>
      </Page>
    </>
  );
};

export default Criteria;
